function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 26",
  transform: "translate(-1451 -1364)"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 4",
  cx: 41,
  cy: 40,
  rx: 41,
  ry: 40,
  transform: "translate(1451 1364)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-heart",
  d: "M1507.235 1387.089c-4.18-4.083-10.396-3.349-14.232 1.19l-1.5 1.775-1.5-1.775c-3.834-4.539-10.058-5.273-14.237-1.19-4.791 4.688-5.042 13.1-.755 18.181l14.758 17.472a2.187 2.187 0 003.455 0l14.758-17.472c4.293-5.081 4.042-13.493-.747-18.181z",
  fill: "#f9cec8"
}));
var SvgHeartIcon = function SvgHeartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 80"
  }, props), _ref);
};
export default SvgHeartIcon;